enum HomeScoreCategory {
    NotApplicable = 'NotApplicable',
    Bronze = 'Bronze',
    Silver = 'Silver',
    Gold = 'Gold',
  }
  
  export default HomeScoreCategory;
  